export const PANEL_SIDEBAR_COLLAPSED_KEY = 'panel:sidebar-collapsed';

export function readPanelSidebarCollapsed(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.localStorage.getItem(PANEL_SIDEBAR_COLLAPSED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writePanelSidebarCollapsed(collapsed: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(PANEL_SIDEBAR_COLLAPSED_KEY, collapsed ? 'true' : 'false');
  } catch {
    // Ignore localStorage write failures and keep sidebar usable.
  }
}
